import script from "./ChatThread.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatThread.vue?vue&type=script&lang=ts&setup=true"

import "./ChatThread.vue?vue&type=style&index=0&id=6b898a00&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b898a00"]])

export default __exports__